export default __webpack_public_path__ + "static/media/icon-wallet.2325fc27.svg";